import dayjs from 'dayjs';
import 'dayjs/locale/ja';

/**
 * dayjs グローバル設定
 * 日本語ロケールの設定
 */
export const initializeDayjs = (): void => {
  dayjs.locale('ja');
};
